<template>
  <div class="topbar-item">
    <div
      id="kt_quick_user_toggle"
      class="d-flex align-items-center px-md-2 w-md-auto btn btn-hover-transparent-white btn-icon btn-lg"
    >
      <span
        class="d-md-inline opacity-70 mr-1 font-size-base font-weight-bold text-white d-none"
      >
        Hi,
      </span>
      <span
        class="d-md-inline opacity-90 mr-4 font-size-base font-weight-bolder text-white d-none"
      >
        {{ currentUser.name }}
      </span>
      <span class="symbol symbol-35">
        <span
          class="bg-white-o-30 font-size-h5 font-weight-bold text-white symbol-label"
        >
          {{ acronym }}
        </span>
      </span>
    </div>

    <div
      id="kt_quick_user"
      ref="kt_quick_user"
      class="offcanvas-right p-10 offcanvas"
    >
      <!--begin::Header-->
      <div
        class="d-flex justify-content-between align-items-center pb-5 offcanvas-header"
      >
        <h3 class="m-0 font-weight-bold">
          User Profile
          <!-- <small class="ml-2 font-size-sm text-muted">12 messages</small> -->
        </h3>
        <a
          href="#"
          class="btn btn-hover-primary btn-icon btn-light btn-xs"
          id="kt_quick_user_close"
        >
          <i class="text-muted icon-xs ki ki-close"></i>
        </a>
      </div>
      <!--end::Header-->

      <!--begin::Content-->
      <perfect-scrollbar
        class="mr-n5 pr-5 offcanvas-content scroll"
        style="max-height: 90vh; position: relative"
      >
        <!--begin::Header-->
        <div class="d-flex align-items-center mt-5">
          <div class="mr-5 symbol symbol-100">
            <img class="symbol-label" :src="picture" alt="" />
            <i class="bg-success symbol-badge"></i>
          </div>
          <div class="d-flex flex-column">
            <a
              href="#"
              class="font-size-h5 font-weight-bold text-dark-75 text-hover-primary"
            >
              {{ currentUser.name }}
            </a>
            <div class="mt-1 text-muted">{{ currentUser.role }}</div>
            <div class="mt-2 navi">
              <a href="#" class="navi-item">
                <span class="p-0 pb-2 navi-link">
                  <span class="mr-1 navi-icon">
                    <span class="svg-icon svg-icon-lg svg-icon-primary">
                      <!--begin::Svg Icon-->
                      <inline-svg
                        src="media/svg/icons/Communication/Mail-notification.svg"
                      />
                      <!--end::Svg Icon-->
                    </span>
                  </span>
                  <span class="text-hover-primary text-muted navi-text">
                    {{ currentUser.email }}
                  </span>
                </span>
              </a>
            </div>
            <button class="btn btn-bold btn-light-primary" @click="onLogout">
              Sign out
            </button>
          </div>
        </div>
        <!--end::Header-->
        <!-- <div class="mt-8 mb-5 separator separator-dashed"></div> -->
        <!-- <div class="p-0 navi navi-spacer-x-0">
          <router-link
            to="/builder"
            @click.native="closeOffcanvas"
            href="#"
            class="navi-item"
          >
            <div class="navi-link">
              <div class="bg-light mr-3 symbol symbol-40">
                <div class="symbol-label">
                  <span class="svg-icon svg-icon-md svg-icon-success">
                    <inline-svg
                      src="media/svg/icons/General/Notification2.svg"
                    />
                  </span>
                </div>
              </div>
              <div class="navi-text">
                <div class="font-weight-bold">My Profile</div>
                <div class="text-muted">
                  Account settings and more
                  <span
                    class="label-inline font-weight-bold label label-light-danger"
                  >
                    update
                  </span>
                </div>
              </div>
            </div>
          </router-link>
          <router-link
            to="/builder"
            @click.native="closeOffcanvas"
            href="#"
            class="navi-item"
          >
            <div class="navi-link">
              <div class="bg-light mr-3 symbol symbol-40">
                <div class="symbol-label">
                  <span class="svg-icon svg-icon-md svg-icon-warning">
                    <inline-svg src="media/svg/icons/Shopping/Chart-bar1.svg" />
                  </span>
                </div>
              </div>
              <div class="navi-text">
                <div class="font-weight-bold">My Messages</div>
                <div class="text-muted">Inbox and tasks</div>
              </div>
            </div>
          </router-link>
          <router-link
            to="/builder"
            @click.native="closeOffcanvas"
            href="#"
            class="navi-item"
          >
            <div class="navi-link">
              <div class="bg-light mr-3 symbol symbol-40">
                <div class="symbol-label">
                  <span class="svg-icon svg-icon-danger svg-icon-md">
                    <inline-svg src="media/svg/icons/Files/Selected-file.svg" />
                  </span>
                </div>
              </div>
              <div class="navi-text">
                <div class="font-weight-bold">My Activities</div>
                <div class="text-muted">Logs and notifications</div>
              </div>
            </div>
          </router-link>
          <router-link
            to="/builder"
            @click.native="closeOffcanvas"
            href="#"
            class="navi-item"
          >
            <div class="navi-link">
              <div class="bg-light mr-3 symbol symbol-40">
                <div class="symbol-label">
                  <span class="svg-icon svg-icon-md svg-icon-primary">
                    <inline-svg
                      src="media/svg/icons/Communication/Mail-opened.svg"
                    />
                  </span>
                </div>
              </div>
              <div class="navi-text">
                <div class="font-weight-bold">My Tasks</div>
                <div class="text-muted">latest tasks and projects</div>
              </div>
            </div>
          </router-link>
        </div> -->
        <div class="my-7 separator separator-dashed"></div>
        <!--begin::Notifications-->
        <!-- <div>
          <h5 class="mb-5">Recent Notifications</h5>
          <template v-for="(item, i) in list">
            <div
              class="d-flex align-items-center p-5 rounded gutter-b"
              v-bind:class="`bg-light-${item.type}`"
              v-bind:key="i"
            >
              <span
                class="mr-5 svg-icon"
                v-bind:class="`svg-icon-${item.type}`"
              >
                <span class="svg-icon svg-icon-lg">
                  <inline-svg :src="item.svg" />
                </span>
              </span>
              <div class="d-flex flex-column flex-grow-1 mr-2">
                <a
                  href="#"
                  class="mb-1 font-size-lg font-weight-normal text-dark-75 text-hover-primary"
                >
                  {{ item.title }}
                </a>
                <span class="font-size-sm text-muted">
                  {{ item.desc }}
                </span>
              </div>
              <span
                class="py-1 font-size-lg font-weight-bolder"
                v-bind:class="`text-${item.type}`"
              >
                {{ item.alt }}
              </span>
            </div>
          </template>
        </div> -->
      </perfect-scrollbar>
      <!--end::Content-->
    </div>
  </div>
</template>

<style lang="scss" scoped>
#kt_quick_user {
  overflow: hidden;
}
</style>

<script>
import { LOGOUT } from "@/core/services/store/auth.module";
import KTLayoutQuickUser from "@/assets/js/layout/extended/quick-user.js";
import KTOffcanvas from "@/assets/js/components/offcanvas.js";
import { mapGetters } from "vuex";

export default {
  name: "KTQuickUser",
  data() {
    return {
      list: [
        {
          title: "Another purpose persuade",
          desc: "Due in 2 Days",
          alt: "+28%",
          svg: "media/svg/icons/Home/Library.svg",
          type: "warning",
        },
        {
          title: "Would be to people",
          desc: "Due in 2 Days",
          alt: "+50%",
          svg: "media/svg/icons/Communication/Write.svg",
          type: "success",
        },
        {
          title: "Purpose would be to persuade",
          desc: "Due in 2 Days",
          alt: "-27%",
          svg: "media/svg/icons/Communication/Group-chat.svg",
          type: "danger",
        },
        {
          title: "The best product",
          desc: "Due in 2 Days",
          alt: "+8%",
          svg: "media/svg/icons/General/Attachment2.svg",
          type: "info",
        },
      ],
    };
  },
  mounted() {
    // Init Quick User Panel
    KTLayoutQuickUser.init(this.$refs["kt_quick_user"]);
  },
  methods: {
    onLogout() {
      this.$store
        .dispatch(LOGOUT)
        .then(() => this.$router.push({ name: "login" }));
    },
    closeOffcanvas() {
      new KTOffcanvas(KTLayoutQuickUser.getElement()).hide();
    },
  },
  computed: {
    ...mapGetters(["currentUser"]),
    picture() {
      return process.env.BASE_URL + "assets/profile.svg";
    },
    acronym() {
      if (!this.currentUser.id) return "";
      const name = this.currentUser.name + " "; // space character here to avoid nameParts[1] being undefined
      const nameParts = name.split(" ");
      return nameParts[0].slice(0, 1) + nameParts[1].slice(0, 1);
    },
  },
};
</script>
